import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useApi } from '../lib/useApi';
import { ErrorBox, Loading, NeedsReviewBadge, PageHeader, StatusBadge, LoadFailed } from '../components/ui';

interface RootsResp {
  lessons: Array<{ id: string; title: string; level: number; game_type: string; review_status: string }>;
  projects: Array<{ key: string; title: string; prompt: string }>;
  stories: Array<{ id: string; title: string; type: string; review_status: string }>;
  cowries: number;
  privacy: string;
}

export function TeenRootsPage() {
  const { data, error, loading, reload } = useApi<RootsResp>('/teen/roots');
  if (loading) return <Loading />;
  if (error || !data) return <LoadFailed error={error} onRetry={reload} />;
  return (
    <>
      <PageHeader title="Roots" termKey="page.roots" lead="For 13–17s: go deeper — oríkì, proverbs, history, and interviewing the elders who carry your family’s story." />
      <p className="alert info small with-icon">
        <Lock size={17} strokeWidth={1.75} aria-hidden="true" />
        <span>{data.privacy}</span>
      </p>
      <div className="grid grid-2">
        <section className="card stack">
          <h2>Projects</h2>
          {data.projects.map((p) => (
            <div key={p.key}>
              <h3 style={{ marginBottom: 2 }}>{p.title}</h3>
              <p className="small">{p.prompt}</p>
            </div>
          ))}
          <Link className="btn secondary" to="/stories">
            Record an interview in the Story Vault
          </Link>
        </section>
        <section className="stack">
          <div className="card">
            <h2>Teen lessons</h2>
            <ul>
              {data.lessons.map((l) => (
                <li key={l.id}>
                  <span className="yo">{l.title}</span> <span className="small muted">level {l.level}</span> {l.review_status !== 'approved' && <NeedsReviewBadge />}
                </li>
              ))}
            </ul>
          </div>
          <div className="card">
            <h2>Your recordings</h2>
            {data.stories.length === 0 && <p className="muted">Nothing yet.</p>}
            <ul>
              {data.stories.map((s) => (
                <li key={s.id}>
                  <span className="yo">{s.title}</span> <StatusBadge status={s.review_status} />
                </li>
              ))}
            </ul>
            <p className="cowrie">🐚 {data.cowries} cowries</p>
          </div>
        </section>
      </div>
    </>
  );
}
